import { useEffect, useState } from "react";
import { Phone, ArrowRight, MessageCircle } from "lucide-react";
import TrackedPhoneLink from "@/components/site/TrackedPhoneLink";

/**
 * MobileStickyCTA · Sticky-Bottom-Bar nur auf Mobile.
 * - Erscheint erst nach 400 px Scroll (nicht über dem Hero)
 * - Fade-in Animation
 * - Hidden bei md+ (≥768 px) → Desktop bekommt sie nicht zu sehen
 * - Berührt Cookie-Banner nicht (höherer z-index nur für die Bar selbst,
 *   und sie ist 64 px hoch – Cookie-Banner überlagert sie sauber, weil
 *   Cookie-Banner z-index ≥ 50, wir nutzen z-40)
 */
export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
      aria-hidden={!visible}
    >
      <div className="bg-cream-50/95 backdrop-blur-md border-t border-cream-300 px-3 py-2.5 flex items-center gap-2 shadow-[0_-4px_20px_rgba(141,75,50,0.08)]">
        <TrackedPhoneLink
          source="mobile-sticky-cta"
          data-testid="mobile-sticky-phone"
          className="flex items-center justify-center w-12 h-12 rounded-full bg-cream-100 border border-cream-300 text-sand-800 hover:bg-cream-200 transition-colors shrink-0"
          aria-label="0211 29273330 anrufen"
        >
          <Phone className="h-5 w-5" strokeWidth={1.8} />
        </TrackedPhoneLink>

        <a
          href="https://wa.me/491622572545?text=Hallo!%20Ich%20habe%20eine%20Frage%20zu%20euren%20Kursen."
          target="_blank" rel="noreferrer"
          data-testid="mobile-sticky-whatsapp"
          aria-label="Bei WhatsApp schreiben"
          className="flex items-center justify-center w-12 h-12 rounded-full bg-cream-100 border border-cream-300 text-sand-800 hover:bg-cream-200 transition-colors shrink-0"
        >
          <MessageCircle className="h-5 w-5" strokeWidth={1.8} />
        </a>

        <a
          href="/#kontakt"
          data-testid="mobile-sticky-beratung"
          className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-terra hover:bg-terra-dark text-white font-semibold text-[15px] transition-colors"
        >
          Kostenlose Beratung
          <ArrowRight className="h-4 w-4" strokeWidth={2} />
        </a>
      </div>
    </div>
  );
}
